var React = require('react');

function LightningInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.9997 7L17.9997 1H8.9997L3.14442 12.7106C3.07793 12.8435 3.17463 13 3.32331 13H9.0397L6.23223 22.2351C6.17168 22.4343 6.4178 22.5819 6.565 22.4347L21.6583 7.34142C21.7843 7.21543 21.695 7 21.5169 7H14.9997ZM10.2347 3H14.7637L11.7636 9H17.1697L10.2377 15.932L11.7381 11H6.2347L10.2347 3Z","fill":"#131416"}));
}

LightningInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LightningInline;

LightningInline.default = LightningInline;
